import React, { Component } from 'react'
import About from './About';
import Discover from './Discover';
import Footer from './Footer';
import MainSlider from './MainSlider';
import Nav from './Nav';
import NSA from './NSA';
import SectionThree from './SectionThree';
import SectionTwo from './SectionTwo';

export default class Home extends Component {
    render() {
        return (
            <div>
                <Nav />

                <MainSlider />

                <About />

                <NSA />

                <SectionTwo />

                <Footer />
            </div>
        )
    }
}
